<template>
  <div id="app">
    <Top></Top>
    <div class="content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <Footer></Footer>

    <ScrollToTop>
      <b-button pill class="btn btn-circle blue-bg btn-md">
        <i class="material-icons arrow">arrow_upward</i>
      </b-button>
    </ScrollToTop>
  </div>
</template>


<script>
import Top from "./components/Top";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

export default {
  name: "App",
  components: {
    Top,
    Footer,
    ScrollToTop,
  },
  created() {
    const promise = this.$store.dispatch("getAll");

    promise
      .then((e) => {
        this.$store.dispatch("getSpeakers");
        this.$store.dispatch("getSessions");
      })
      .catch((e) => {
        console.log(e);
      });

    // this.$store.dispatch("mongoDB");
  },
  watch: {},
  computed: {},
  methods: {
    // filter out old schedules and set counter
    filterOldSchedules() {
      this.$store.dispatch("filterOldSchedules");
    },
  },
  mounted() {
    // Call the method when the component is mounted
    this.filterOldSchedules();
  },
};
</script>

<style lang="scss">
@import "./styles/variables.scss";
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap");

@media screen and (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.001ms !important;
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
  }
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: Outfit, Outfit, Geneva, sans-serif !important;

  font-size: 1rem !important;
  background-color: white !important;
  color: $text-dark !important;
}

//Global helpers and classes
.weight-300 {
  font-weight: 300;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-break {
  flex-basis: 100%;
  height: 0;
}

.pointer {
  cursor: pointer !important;
}

.bg-purple {
  background-color: $purple;
}
.bg-pink {
  background-color: $pink;
}
.bg-red {
  background-color: $red;
}
.bg-blue {
  background-color: $blue;
}
.bg-green {
  background-color: $green;
}
.bg-yellow {
  background-color: $yellow;
}

.bg-grey-light {
  background-color: $grey-light;
}

.modal-header {
  color: $text-dark !important;
  background-color: white !important;
}
.modal-header button {
  color: $text-dark !important;
  background-color: white !important;
}
.modal-title {
  color: $text-dark !important;
  background-color: white !important;
}
.modal-body {
  color: $text-dark !important;
  background-color: white !important;
}
.modal-body p {
  color: $text-dark !important;
}

.modal-footer {
  border-top: none;
}

.bg-color-dark {
  background-color: $bg-dark !important;
}
.bg-color-light {
  background-color: $bg-light !important;
}
.text-color-dark {
  color: $text-dark !important;
}
.text-light {
  color: $text-color-light !important;
}
.pink {
  color: $pink !important;
}
.green {
  color: $green !important;
}
.green-bg {
  background: $green !important;
}
.green-light-bg {
  background: $green-light !important;
}
.purple-light-bg {
  background: $pink !important;
}
.orange {
  color: $orange !important;
}
.orange-bg {
  background-color: $orange !important;
}
.red {
  color: $red !important;
}
.red-bg {
  background-color: $red !important;
}

.big-headline {
  font-size: 2.5rem;
  font-weight: 500;
  margin-bottom: 20px;
  @media (max-width: 576px) {
    font-size: 2rem !important;
  }
}

h1,
h2,
h3,
h4,
h5 {
  font-family: "Outfit", sans-serif;
  font-weight: 500 !important;
}

h1 {
  color: $text-dark;
  @media (max-width: 767px) {
    font-size: 1.6rem !important;
  }
  @media (max-width: 576px) {
    font-size: 1.4rem !important;
  }
}

h2 {
  @media screen and (max-width: 767px) {
    font-size: 1.4rem !important;
  }
  @media screen and (max-width: 576px) {
    font-size: 1.2rem !important;
  }
}

h3 {
  @media (max-width: 767px) {
    font-size: 1.2rem !important;
  }
  @media (max-width: 576px) {
    font-size: 1.1rem !important;
  }
}
h4 {
  @media (max-width: 767px) {
    font-size: 1.1rem !important;
  }
  @media (max-width: 576px) {
    font-size: 1rem !important;
  }
}
h5 {
  @media (max-width: 767px) {
    font-size: 1rem !important;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem !important;
  }
}

p {
  color: $text-color-light;
  font-weight: 300;
}

h1 {
  font-weight: 300;
  font-size: 32px;
}
h2 {
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
}

p,
a,
li,
span,
.btn {
  @media (max-width: 767px) {
    font-size: 0.9rem !important;
  }
}

.hidden {
  display: none !important;
}
a,
a:visited {
  color: #e34407 !important;
  text-decoration: underline !important;
  font-weight: 700;
}

a.text-white {
  color: #fff !important;
}
.btn {
  cursor: pointer;
  font-weight: 700;
}
.btn-lg {
  padding: 20px;
}

/*================ TAGS ===============*/
.tags-container .select {
  text-transform: uppercase;
  color: $green;
  cursor: pointer;
}

.tags-container .tags {
  margin: 0 0 2rem 0;
}
.tags-container .tags .col-xs-6 {
  @media (max-width: 576px) {
    width: 50%;
  }
}
.tag {
  font-size: 1rem;
  margin: 2px -13px;
  border: 2px solid $grey-light;
  height: 4em;
  opacity: 0.5;

  //line-height: 3em;
  text-transform: uppercase;
  padding: 10px 10px;
  cursor: pointer;
  @media (max-width: 992px) {
    font-size: 0.9rem;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
}
.tag:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
}
.tags-add:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
}
.tag-choosen:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
}
.tags-container .select-all {
  @media (max-width: 576px) {
    margin-top: 0;
  }
}
.tags-container .select-all span {
  text-transform: uppercase;
  margin: 0 10px;
}
.tag.active,
.tag-choosen.active {
  border-radius: 10px;
  border: 3px solid;
  opacity: 1;
}
.tag-choosen.active.speaker {
  background-color: $pink;
  color: $text-dark;
}
.tag-choosen {
  border: 3px solid;

  white-space: nowrap;
  display: inline-block;
  border-radius: 10px;
  height: 45px;
  padding: 10px 10px 10px 10px;
  width: auto;
  margin: 0 2px 2px 0;
  z-index: 99;
  cursor: pointer;
  @media (max-width: 992px) {
    padding: 7px 10px 7px 10px;
    height: 40px;
  }
  @media (max-width: 576px) {
    padding: 7px 10px 10px 10px;
    height: 40px;
  }
  color: $text-dark;
  background-color: white;
}
.tag-choosen,
.tags-add {
  font-size: 1rem;
}
.tag-choosen span {
  margin: 0 10px 0 0;
  @media (max-width: 991px) {
    font-size: 0.9rem;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem;
    margin: 0 4px 0 0;
  }
}
.tag-choosen i {
  font-size: 1rem;
  vertical-align: middle;
  @media (max-width: 991px) {
    font-size: 0.9rem;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
}
.tags-add i {
  vertical-align: middle;
}
.tags-add {
  display: inline-block;
  border: 1px solid rgba(0, 128, 0, 0);
  width: 44px;
  height: 44px;
  margin-bottom: 3px;
  padding: 10px;
  background-color: $green;
  color: #fff;
  cursor: pointer;
}

.tag-choosen.active.active-jvm {
  background-color: #de9fc2;
  border-color: #de9fc215 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-web {
  background-color: #de9fc2;
  border-color: #de9fc215 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-net {
  background-color: #2f71d0;
  border-color: #2f72d017 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-quality-test {
  background-color: #2f71d0;
  border-color: #2f72d017 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-cloud-devops {
  background-color: #2f71d0;
  border-color: #2f72d017 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-data {
  background-color: #f9aa41;
  border-color: #f9a94118 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-security {
  background-color: #f9aa41;
  border-color: #f9a94118 !important;
  color: $text-color-light !important;
}

.tag-choosen.active.active-leadership-mgmt {
  background-color: #e34407;
  border-color: #e3450718 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-architecture {
  background-color: #e34407;
  border-color: #e3450718 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-keynote {
  background-color: #e34407;
  border-color: #e3450718 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-ai {
  background-color: #3f875d;
  border-color: #3f875d13 !important;
  color: $text-color-light !important;
}
.tag-choosen.active.active-off {
  background-color: #3f875d;
  border-color: #3f875d13 !important;
  color: $text-color-light !important;
}

.loading-tags {
  margin: 10rem 0 60rem 0;
}
.tags-container .confirm-tags {
  margin: 1rem 0 60rem 0;
}
.btn.btn-circle.disabled {
  background-color: $grey-light !important;
}
.btn.btn-circle {
  background-color: $green !important;
  width: 100px;
  height: 100px;
  text-align: center;
  padding: 20px 0;
  font-size: 40px;
  font-weight: bold;
  line-height: 1.428571429;
  border-radius: 50%;
  cursor: pointer;
}
.btn-circle .material-icons {
  color: #fff;
  font-weight: bold;
  font-size: 50px;
}
/*=================== TAGS END ==================*/

/*=================== SESSIONS ==================*/
.session .add-schedule {
  cursor: pointer;
}
.session.active .add-schedule i,
.session.active .time {
  color: $text-dark;
}
.session.active .add-schedule i.remove {
  display: inline-block;
}
.session.active .add-schedule i.add {
  display: none;
}
.session .add-schedule i.remove {
  display: none;
}
.session .add-schedule i.add {
  display: inline-block;
}

.session {
  margin: 0 0 1em 0;
  background-color: white;
  color: black;
}
.sessions-container .sessions {
  margin-bottom: 8rem;
}
.session .add-schedule i {
  // margin-top: 15px;
}
.session .time h2 {
  font-size: 3.7rem;
  @media (max-width: 1199px) {
    font-size: 2.9rem;
    padding-top: 10px;
  }
  @media (max-width: 991px) {
    font-size: 2rem;
    padding-top: 18px;
  }
  @media (max-width: 767px) {
    font-size: 2.4rem !important;
  }
}
.session .main {
  padding-top: 10px;
}

.session .fold-icons,
.session .session-title {
  display: inline-block;
}
.session .fold-icons {
  width: 3%;
  @media (max-width: 1199px) {
    width: 4%;
  }
  @media (max-width: 991px) {
    width: 5%;
  }
}
.session .session-title {
  width: 97%;
  display: inline-block;
  padding: 3px 0 0 0px;
  font-family: "Outfit";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  @media (max-width: 1199px) {
    width: 96%;
  }
  @media (max-width: 991px) {
    width: 90%;
  }
}

.session .session-info {
  margin-top: 5px;
  padding-top: 5px;
  // border-bottom: 1px solid #cccccc;
  cursor: pointer;
}
.session .session-text {
  margin: 10px 0 0 0;
  @media (max-width: 576px) {
    font-size: 1rem;
  }
}
.session .speaker,
.session .room,
.session .material-icons {
  cursor: pointer;
  color: black;
}
.session .speaker,
.session .room {
  font-family: "Outfit";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}
.sessions-container .days {
  margin: 1em 0 3em 0 !important;
  @media (max-width: 576px) {
    margin-bottom: 0 !important;
  }
}
.sessions-container .days ul {
  padding: 0;
  list-style-type: none;
}

.sessions-container ul.conference,
.sessions-container ul.workshop {
  list-style: none;
  display: inline-block;
}
.sessions-container .conference li,
.sessions-container .workshop li {
  float: left;
  margin-right: 1em;
  text-transform: uppercase;
}
.sessions-container .days li {
  @media (max-width: 991px) {
    font-size: 1.2rem;
  }
  @media (max-width: 767px) {
    font-size: 1rem;
  }
  @media (max-width: 576px) {
    font-size: 0.7rem;
    margin-right: 0.1rem;
  }
}
.sessions-container .days li span {
  @media (max-width: 991px) {
    font-size: 1.5rem;
  }
  @media (max-width: 767px) {
    font-size: 1.2rem;
  }
  @media (max-width: 576px) {
    font-size: 0.9rem;
    margin-right: 0.5rem;
  }
}
.sessions-container .conference li.session-type,
.sessions-container .workshop li.session-type {
  clear: both;
  color: #888;
  border-top: 1px dotted #888;
  width: 100%;
}
/*=================== SESSIONS END==================*/
/*=================== LINE-UP ==================*/
.lineup .speaker-card {
  margin-bottom: 40px;
  z-index: 10;
}
.lineup .speaker-card .speaker-company {
  font-size: 11px;
  color: white;
}
.lineup .speaker-card .speaker-name {
  margin: 10px 0 0 0;
}
.speaker-single {
  z-index: 10;
  position: relative;
}
.speaker-single h4 {
  margin-top: 0px;
}
.arrow {
  font-size: 2rem !important;
}

.btn {
  border: 0 !important;
  border-radius: 30px !important;
  background-color: $yellow !important;
  color: $text-dark !important;
  z-index: 99;
  font-weight: 300 !important;
  border: 2px solid $yellow !important;
}

.btn-1 {
  width: 194px !important;
  height: 56px !important;
  background-color: $yellow !important;
  color: $text-dark !important;
  border: 1px solid $yellow !important;
}
.btn-2 {
  width: 194px !important;
  height: 56px !important;
  background-color: $pink !important;
  color: $text-dark !important;
  border: 2px solid $pink !important;
}

.btn-1:hover {
  color: $text-dark !important;
  background: #d89338 !important;
  border: 1px solid #d89338 !important;
}
.btn-2:hover {
  color: $text-dark !important;
  background: #bf7ca2 !important;
  border: 1px solid #bf7ca2 !important;
}
/*=================== LINE-UP END==================*/

@keyframes clip {
  0% {
    clip-path: polygon(0 100%, 100% 100%, 100% 120%, 0 120%);
  }

  100% {
    clip-path: polygon(0 -20%, 100% -20%, 100% 0%, 0 0);
  }
}
.grecaptcha-badge {
  visibility: hidden !important;
}

.disabled-all {
  opacity: 0.5;
  cursor: default;
}

.disabled-all:hover {
  background-image: none !important;
}

.info-img {
  height: 451px;
  width: inherit;
  object-fit: cover;
  z-index: 999;
  position: relative;
}

@media screen and (max-width: 767px) {
  .info-img {
    height: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue